/**
 * Utility function to convert worth number into $$$ string.
 *
 * E.g.: $8,400,000
 *
 * @param worth - Estimated net worth number.
 */
export const transformWorthString = (worth: number): string => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return formatter.format(worth);
};
